import React from 'react'
import { connect } from 'react-redux'
import { func, number, string } from 'prop-types'
import { productDataType } from 'models/propTypes'
import { setDesignSidepanelMode } from 'models/ui/actions'
import ItemDetailsView from 'components/designSidepanel/ItemDetailsView'
import { deleteCompositionRenderItem, swapRenderItem } from 'models/compositions/actions'
import {
    getSelectedCompositionId,
    getSelectedCompositionRenderedFurnitureItem,
    getSelectedRenderItemId,
} from 'models/compositions/selectors'
import { PRODUCT_SWAP } from 'models/tracking/constants'
import { trackShowDetails as trackShowDetailsAction } from 'models/tracking/actions'
import { addToBag as addToBagAction } from 'models/bag/actions'
import { getDesignSidepanelMode } from 'models/ui/selectors'
import { getSelectedSwapDetailsFurnitureData } from 'models/furniture/selectors'
import { selectSwapFurnitureForDetails } from 'models/furniture/actions'
import * as modes from 'models/ui/constants'
import { getProductTrackingInfo } from 'models/tracking/utils'

const ItemDetailsViewContainer = ({
    setMode,
    productData,
    deleteItem,
    compositionId,
    addToBag,
    trackShowDetails,
    mode,
    onSwap,
    selectedSwapDetailsData,
    selectedRenderItemId,
    clearSwapSelection,
}) => {
    const swapItem = (e) => {
        e.stopPropagation()
        const { id: swappedFurnitureId } = selectedSwapDetailsData
        const swappedInProductTrackingInfo = getProductTrackingInfo(selectedSwapDetailsData)
        const swappedInTrackingInfo = {
            ...swappedInProductTrackingInfo,
            AddedFrom: PRODUCT_SWAP,
        }

        if (productData) {
            const removedProductTrackingInfo = getProductTrackingInfo(productData)

            const removedTrackingInfo = {
                ...removedProductTrackingInfo,
                RemovedFrom: PRODUCT_SWAP,
            }

            const trackingInfo = {
                swappedInTrackingInfo,
                removedTrackingInfo,
            }
            onSwap(selectedRenderItemId, swappedFurnitureId, trackingInfo)
        }
    }

    const removeRenderItem = () => {
        const trackingInfo = getProductTrackingInfo(productData)
        deleteItem(compositionId, productData.uniqueId, trackingInfo)
    }

    const goBack = () => {
        const isInSwap = mode === modes.DESIGN_SIDEPANEL_MODE_SWAP_DETAILS
        const isInFavorites = mode === modes.DESIGN_SIDEPANEL_MODE_FAVORITES_DETAILS
        if (isInSwap) {
            setMode(modes.DESIGN_SIDEPANEL_MODE_SWAP_BROWSE)
            // clear the selected swap details id in the state
            clearSwapSelection()
        } else if (isInFavorites) {
            setMode(modes.DESIGN_SIDEPANEL_MODE_FAVORITES_BROWSE)
        } else {
            setMode(modes.DESIGN_SIDEPANEL_MODE_MYITEMS_BROWSE)
        }
    }

    const isInSwap = mode === modes.DESIGN_SIDEPANEL_MODE_SWAP_DETAILS
    const childProductData = isInSwap ? selectedSwapDetailsData : productData
    const { localItemNumber, region, name: productTitle } = childProductData

    const trackingInfo = getProductTrackingInfo(childProductData)
    const disableSwapCta = childProductData.id === productData.id

    const onAddToBag = () => addToBag(localItemNumber, region, productTitle, trackingInfo)

    return isInSwap ? (
        <ItemDetailsView
            productData={childProductData}
            trackShowDetails={() => trackShowDetails(trackingInfo)}
            addToBag={onAddToBag}
            onBackClick={goBack}
            isInSwap
            swapItem={swapItem}
            disableSwapCta={disableSwapCta}
        />
    ) : (
        <ItemDetailsView
            productData={childProductData}
            trackShowDetails={() => trackShowDetails(trackingInfo)}
            addToBag={onAddToBag}
            onBackClick={goBack}
            deleteItem={removeRenderItem}
        />
    )
}

ItemDetailsViewContainer.defaultProps = {
    selectedSwapDetailsData: null,
    selectedRenderItemId: null,
}

ItemDetailsViewContainer.propTypes = {
    setMode: func.isRequired,
    deleteItem: func.isRequired,
    productData: productDataType.isRequired,
    compositionId: number.isRequired,
    addToBag: func.isRequired,
    trackShowDetails: func.isRequired,
    mode: string.isRequired,
    onSwap: func.isRequired,
    selectedSwapDetailsData: productDataType,
    selectedRenderItemId: number,
    clearSwapSelection: func.isRequired,
}

const mapStateToProps = (state) => ({
    productData: getSelectedCompositionRenderedFurnitureItem(state),
    compositionId: getSelectedCompositionId(state),
    mode: getDesignSidepanelMode(state),
    selectedSwapDetailsData: getSelectedSwapDetailsFurnitureData(state),
    selectedRenderItemId: getSelectedRenderItemId(state),
})

const mapDispatchToProps = (dispatch) => ({
    setMode: (mode) => dispatch(setDesignSidepanelMode(mode)),
    deleteItem: (...args) => dispatch(deleteCompositionRenderItem(...args)),
    addToBag: (...args) => dispatch(addToBagAction(...args)),
    trackShowDetails: (info) => dispatch(trackShowDetailsAction(info)),
    clearSwapSelection: () => dispatch(selectSwapFurnitureForDetails(-1)),
    onSwap: (...args) => dispatch(swapRenderItem(...args)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ItemDetailsViewContainer)
